import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-skeleton-loader';

const StyledLoader = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 3rem;

	.image .react-skeleton-load {
		padding-top: 75%;
	}
`;

const StyledInfo = styled.div`
	display: flex;
	padding: 10px 0;
	margin: 0 -10px;

	> span {
		flex-basis: 100%;
		padding: 0 5px;
	}
`;

const StyledNameRow = styled.div`
	display: flex;
	justify-content: space-between;

	> span {
		flex-basis: 100%;

		&:last-child {
			text-align: right;
		}
	}
`;

const ApartmentBoxLoader = () => {
	return (
		<StyledLoader>
			<div className="image">
				<Skeleton width="100%" height="75%" widthRandomness="0" />
			</div>
			<StyledInfo>
				<Skeleton width="100%" height="23px" widthRandomness="0" />
				<Skeleton width="100%" height="23px" widthRandomness="0" />
				<Skeleton width="100%" height="23px" widthRandomness="0" />
			</StyledInfo>
			<div>
				<Skeleton width="25%" height="23px" widthRandomness="0" />
			</div>
			<StyledNameRow>
				<Skeleton width="80%" height="23px" widthRandomness="0" />
				<Skeleton width="70%" height="23px" widthRandomness="0" />
			</StyledNameRow>
		</StyledLoader>
	);
};

export default ApartmentBoxLoader;
